import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

import { isProductionEnvironment } from "utils/env";

import { TableColumnMeta } from "../../types";
import makeTableColumnsSlice from "./makeTableColumnsSlice";
import { TableColumnsState } from "./types";

type UseTableStoreConfig = {
  storageKey: string;
  config: Record<string, TableColumnMeta>;
};

const createTableStore = ({ storageKey, config }: UseTableStoreConfig) =>
  create<TableColumnsState>()(
    devtools(
      persist(
        immer((...a) => ({
          ...makeTableColumnsSlice(config)(...a),
        })),
        {
          name: storageKey,
          partialize: (state) => ({
            columnsOrder: state.columnsOrder,
            columnsSizes: state.columnsSizes,
            isFirstColumnPinned: state.isFirstColumnPinned,
          }),
          version: 5,
          merge: (persistedState, currentState) => ({
            ...currentState,
            ...(persistedState as Partial<TableColumnsState>),
          }),
        }
      ),
      { enabled: !isProductionEnvironment() }
    )
  );

export default createTableStore;
